import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Case } from '../models/case';
import { ApiService } from './api.service';

@Injectable()
export class PreSignService {

  apiService: ApiService = new ApiService(this.http);

  baseUrl = environment.preSign;

  constructor(
    private http: Http
  ) { }

  getPresign(orgId, caseId, fileName) {
    return this.apiService.getCall('preSign', `organizations/${orgId}/cases/${caseId}/presign/${fileName}`);
  }
  getOrderPresign(orgId, caseId, fileName) {
    return this.apiService.getCall('preSign', `organizations/${orgId}/cases/${caseId}/presign/${fileName}?docType=orders`);
  }

  getList(orgId, caseId, inlineCheck) {
    if(inlineCheck){
      // return this.apiService.getCall('preSign', `organizations/${orgId}/cases/${caseId}/list?disposition=inline`);
      return this.apiService.getCall('preSign', `organizations/${orgId}/cases/${caseId}/list`);
    }
    return this.apiService.getCall('preSign', `organizations/${orgId}/cases/${caseId}/list`);
  }
  getOrderList(orgId, caseId, inlineCheck) {
    if(inlineCheck){
      // return this.apiService.getCall('preSign', `organizations/${orgId}/cases/${caseId}/list?disposition=inline`);
      return this.apiService.getCall('preSign', `organizations/${orgId}/cases/${caseId}/list?docType=orders`);
    }
    return this.apiService.getCall('preSign', `organizations/${orgId}/cases/${caseId}/list?docType=orders`);
  }

  getPresignForAlert(orgId, caseId, alertId, fileName) {
    return this.apiService.getCall('preSign', `organizations/${orgId}/cases/${caseId}/alerts/${alertId}/presign/${fileName}`);
  }

  getListForAlert(orgId, caseId, alertId) {
    return this.apiService.getCall('preSign', `organizations/${orgId}/cases/${caseId}/alerts/${alertId}/list`);
  }

  // downloadFile(link){
  //   return this.apiService.getCallNoJSON(link);
  // }

  uploadFile(link, file) {
    let url: string[] = link.split('https://dev-eguard-documents.s3.amazonaws.com/')
    return this.apiService.patchCall(link, file);
  }

}



// WEBPACK FOOTER //
// ./src/app/main/shared/services/preSign.service.ts